import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import FollowingPage from "./pages/FollowingPage";
import FormPage from "./pages/FormPage";
import WorkOrderDetailsPage from "./pages/WorkOrderDetailsPage";
import SharedLandingPage from "./pages/SharedLandingPage";
import BulkDownloadPage from "./pages/BulkDownloadPage";
import HelpPage from "./pages/HelpPage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<HomePage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="following" element={<FollowingPage />} />
          <Route path="request" element={<FormPage />} />
          <Route path="details/:uuid" element={<WorkOrderDetailsPage />} />
          <Route path="bulkDownload/:uuid" element={<BulkDownloadPage />} />
          <Route path="public/landing/:token" element={<SharedLandingPage />} />
          <Route path="help" element={<HelpPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
